// extracted by mini-css-extract-plugin
export default {"Content":"Policies_Content__5si04"};